import PropTypes from 'prop-types';
import React from 'react';
import { TopOffsetContext } from '../../context/topOffset';
const TopOffsetContextProvider = ({ topOffset, children })=>{
    return /*#__PURE__*/ React.createElement(TopOffsetContext.Provider, {
        value: topOffset
    }, children);
};
TopOffsetContextProvider.propTypes = {
    children: PropTypes.any,
    topOffset: PropTypes.number
};
export default TopOffsetContextProvider;
